import api from 'service/api'

const dponetAPI = api.create('dponet')

const verify = async (storeId: string) =>
  await dponetAPI.get(`/tray/verify/${storeId}`)

const install = async (data = {}) => {
  return await dponetAPI.post('/tray/install', data)
}

export default {
  verify,
  install,
}
